// Translations for OmniServe-Solutions in 5 languages
export const translations = {
  de: {
    nav: { home: "Start", services: "Dienstleistungen", tax: "Steuererklärung", about: "Über uns", contact: "Kontakt", cta: "Offerte anfragen" },
    hero: {
      eyebrow: "Versicherung · Finanzen · Steuererklärung",
      title: "Vertrauen, das Sie",
      titleAccent: "spüren.",
      subtitle: "Wir begleiten Privatpersonen, Familien und Selbständige in der Schweiz mit persönlicher, transparenter Beratung – alles aus einer Hand.",
      primary: "Kostenlose Offerte",
      secondary: "Unsere Leistungen",
    },
    trust: {
      title: "Warum OmniServe",
      headline: "Ein Anspruch, der sich nicht in Kompromissen misst.",
      items: [
        { k: "01", t: "Transparent & fair", d: "Klare Kommunikation, keine versteckten Kosten. Sie wissen jederzeit, woran Sie sind." },
        { k: "02", t: "Rückmeldung in 24h", d: "Wir melden uns innerhalb von 24 Stunden – verbindlich und persönlich." },
        { k: "03", t: "Persönlich & diskret", d: "Ein fester Ansprechpartner, der Ihre Situation versteht und langfristig begleitet." },
      ],
    },
    servicesPreview: {
      eyebrow: "Unsere Expertise",
      title: "Alles aus einer Hand",
      subtitle: "Von der Grundversicherung bis zur Vorsorge – wir strukturieren Ihre Absicherung mit Klarheit und Weitblick.",
      cta: "Alle Dienstleistungen ansehen",
    },
    servicesList: [
      { id: "krankenversicherung", t: "Krankenversicherung", d: "Ihre Gesundheit in besten Händen. Wir vergleichen Grund- und Zusatzversicherungen." },
      { id: "lebensversicherung", t: "Lebensversicherung 3a / 3b", d: "Sichern Sie Ihre Liebsten und Ihre Vorsorge langfristig ab." },
      { id: "motorfahrzeug", t: "Motorfahrzeugversicherung", d: "Schutz für Auto, Insassen und Schäden – zu fairen Konditionen." },
      { id: "hausrat", t: "Hausratversicherung", d: "Ihr Zuhause verdient besten Schutz gegen Feuer, Wasser und Diebstahl." },
      { id: "privathaftpflicht", t: "Privathaftpflicht", d: "Gut abgesichert, wenn im Alltag mal etwas passiert." },
      { id: "rechtsschutz", t: "Rechtsschutz", d: "Ihr starker Partner, wenn es rechtlich darauf ankommt." },
      { id: "reise", t: "Reiseversicherung", d: "Unbeschwert reisen – wir schützen Sie weltweit." },
      { id: "kmu", t: "KMU-Versicherung", d: "Rundum-Schutz für Ihr Unternehmen und Ihre Mitarbeitenden." },
      { id: "steuererklaerung", t: "Steuererklärung", d: "Wir füllen Ihre Steuererklärung aus – zum Fixpreis ab CHF 79.–." },
    ],
    servicesPage: {
      eyebrow: "Leistungen",
      title: "Dienstleistungen im Überblick",
      subtitle: "Acht Kompetenzfelder, ein Ansprechpartner. Jede Beratung ist auf Ihre Lebenssituation zugeschnitten.",
    },
    about: {
      eyebrow: "Über uns",
      title: "Ein Partner. Für alles, was zählt.",
      p1: "OmniServe-Solutions ist Ihre unabhängige Anlaufstelle für Versicherungen, Finanzen und Administration in der Schweiz. Wir verbinden Schweizer Präzision mit menschlicher Nähe.",
      p2: "Unser Anspruch: Sie sollen sich sicher fühlen – heute, morgen und in jeder Lebensphase. Dafür nehmen wir uns Zeit, hören zu und finden die Lösung, die zu Ihnen passt.",
      valuesTitle: "Unsere Werte",
      values: [
        { t: "Unabhängigkeit", d: "Wir vergleichen den Markt und empfehlen nur, was Ihnen wirklich dient." },
        { t: "Langfristigkeit", d: "Wir denken in Jahrzehnten, nicht in Provisionen." },
        { t: "Klarheit", d: "Verständliche Sprache, transparente Vorschläge, klare Entscheidungen." },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Sprechen wir.",
      subtitle: "Beschreiben Sie Ihr Anliegen – wir melden uns innerhalb von 24 Stunden mit einem persönlichen Vorschlag.",
      form: {
        name: "Name", email: "E-Mail", phone: "Telefon (optional)", service: "Interessensgebiet", servicePh: "Bitte wählen…", message: "Ihre Nachricht", submit: "Anfrage senden", sending: "Wird gesendet…",
        success: "Vielen Dank! Wir melden uns in Kürze.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      details: { addressLabel: "Adresse", address: "Rigistrasse 2, 5610 Wohlen", emailLabel: "E-Mail", webLabel: "Web", phoneLabel: "Telefon", hoursLabel: "Öffnungszeiten", hours: "Mo–Fr · 15:00 – 19:00" },
    },
    tax: {
      eyebrow: "Neu · Fixpreis",
      title: "Steuererklärung ausfüllen lassen",
      subtitle: "Wir übernehmen Ihre Steuererklärung – professionell, pünktlich, zum transparenten Fixpreis.",
      cta: "Termin vereinbaren",
      note: "Alle Preise in CHF. Digitale Einreichung inklusive.",
      badge: "Beliebt",
      currency: "CHF",
      tiers: [
        { name: "Einzelperson", price: "79", desc: "Für Alleinstehende. Vollständige Bearbeitung, digitale Einreichung.", features: ["Vollständiges Ausfüllen", "Digitale Einreichung", "Optimierte Abzüge", "Persönliche Beratung"] },
        { name: "Familie", price: "99", desc: "Für Ehepaare & Familien. Alle Abzüge, alle Kinder, keine Sorgen.", features: ["Alles aus Einzelperson", "Familien- & Kinderabzüge", "Ehegatten-Splitting", "Priorisierte Bearbeitung"], featured: true },
        { name: "Mit Immobilien", price: "119", desc: "Wenn Sie Wohneigentum besitzen. Inkl. Eigenmietwert & Unterhaltskosten.", features: ["Alles aus Familie", "Eigenmietwert-Berechnung", "Unterhaltskosten-Abzug", "Hypothekar-Zinsen"] },
      ],
    },
    footer: {
      tagline: "Versicherungsberatung, Finanzen & Steuererklärung – persönlich, zuverlässig, kompetent.",
      rights: "Alle Rechte vorbehalten.",
      privacy: "Datenschutz",
      imprint: "Impressum",
    },
  },

  en: {
    nav: { home: "Home", services: "Services", tax: "Tax return", about: "About", contact: "Contact", cta: "Request quote" },
    hero: {
      eyebrow: "Insurance · Finance · Administration",
      title: "Trust you can",
      titleAccent: "feel.",
      subtitle: "We support individuals, families and the self-employed across Switzerland with personal, transparent advice – all from a single source.",
      primary: "Free quote",
      secondary: "Our services",
    },
    trust: {
      title: "Why OmniServe",
      headline: "A standard that isn't measured in compromises.",
      items: [
        { k: "01", t: "Transparent & fair", d: "Clear communication, no hidden fees. You always know where you stand." },
        { k: "02", t: "Reply within 24h", d: "We get back to you within 24 hours – reliable and personal." },
        { k: "03", t: "Personal & discreet", d: "A dedicated advisor who understands your situation for the long run." },
      ],
    },
    servicesPreview: {
      eyebrow: "Our expertise",
      title: "All from a single source",
      subtitle: "From basic health insurance to retirement planning – we structure your coverage with clarity and foresight.",
      cta: "See all services",
    },
    servicesList: [
      { id: "krankenversicherung", t: "Health insurance", d: "Your health in the best hands. We compare basic and supplementary coverage." },
      { id: "lebensversicherung", t: "Life insurance 3a / 3b", d: "Protect your loved ones and secure your retirement long-term." },
      { id: "motorfahrzeug", t: "Motor insurance", d: "Coverage for car, occupants and damages – at fair terms." },
      { id: "hausrat", t: "Household insurance", d: "Your home deserves the best protection against fire, water and theft." },
      { id: "privathaftpflicht", t: "Personal liability", d: "Well covered when everyday mishaps happen." },
      { id: "rechtsschutz", t: "Legal protection", d: "A strong partner when legal matters count." },
      { id: "reise", t: "Travel insurance", d: "Travel worry-free – we protect you worldwide." },
      { id: "kmu", t: "SME insurance", d: "All-round protection for your business and employees." },
      { id: "steuererklaerung", t: "Tax return", d: "We file your Swiss tax return – fixed price from CHF 79.–." },
    ],
    servicesPage: {
      eyebrow: "Services",
      title: "Services at a glance",
      subtitle: "Eight areas of expertise, one point of contact. Every consultation is tailored to your life situation.",
    },
    about: {
      eyebrow: "About us",
      title: "One partner. For everything that matters.",
      p1: "OmniServe-Solutions is your independent point of contact for insurance, finance and administration in Switzerland. We combine Swiss precision with a human touch.",
      p2: "Our promise: you should feel safe – today, tomorrow and at every stage of life. That's why we take the time to listen and find the solution that truly fits.",
      valuesTitle: "Our values",
      values: [
        { t: "Independence", d: "We scan the market and only recommend what truly serves you." },
        { t: "Long-term thinking", d: "We think in decades, not commissions." },
        { t: "Clarity", d: "Plain language, transparent proposals, clear decisions." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk.",
      subtitle: "Describe your request – we'll respond within 24 hours with a personal proposal.",
      form: {
        name: "Name", email: "Email", phone: "Phone (optional)", service: "Area of interest", servicePh: "Please select…", message: "Your message", submit: "Send request", sending: "Sending…",
        success: "Thank you! We'll be in touch shortly.",
        error: "Something went wrong. Please try again.",
      },
      details: { addressLabel: "Address", address: "Rigistrasse 2, 5610 Wohlen", emailLabel: "Email", webLabel: "Web", phoneLabel: "Phone", hoursLabel: "Opening hours", hours: "Mon–Fri · 15:00 – 19:00" },
    },
    tax: {
      eyebrow: "New · Fixed price",
      title: "Let us file your tax return",
      subtitle: "We handle your Swiss tax return – professionally, on time, at a transparent fixed price.",
      cta: "Book an appointment",
      note: "All prices in CHF. Digital submission included.",
      badge: "Popular",
      currency: "CHF",
      tiers: [
        { name: "Single person", price: "79", desc: "For singles. Complete processing, digital submission.", features: ["Complete filing", "Digital submission", "Optimised deductions", "Personal consultation"] },
        { name: "Family", price: "99", desc: "For couples & families. All deductions, all children, no worries.", features: ["Everything from Single", "Family & child deductions", "Spouse splitting", "Priority processing"], featured: true },
        { name: "With property", price: "119", desc: "If you own property. Incl. imputed rental value & maintenance costs.", features: ["Everything from Family", "Imputed rental value", "Maintenance deductions", "Mortgage interest"] },
      ],
    },
    footer: {
      tagline: "Insurance advisory, finance & tax return – personal, reliable, competent.",
      rights: "All rights reserved.",
      privacy: "Privacy",
      imprint: "Imprint",
    },
  },

  fr: {
    nav: { home: "Accueil", services: "Services", tax: "Déclaration", about: "À propos", contact: "Contact", cta: "Demander une offre" },
    hero: {
      eyebrow: "Assurance · Finance · Déclaration d'impôt",
      title: "Une confiance qui se",
      titleAccent: "ressent.",
      subtitle: "Nous accompagnons particuliers, familles et indépendants en Suisse avec un conseil personnel et transparent – tout au même endroit.",
      primary: "Offre gratuite",
      secondary: "Nos services",
    },
    trust: {
      title: "Pourquoi OmniServe",
      headline: "Une exigence qui ne se mesure pas en compromis.",
      items: [
        { k: "01", t: "Transparent & équitable", d: "Une communication claire, sans frais cachés. Vous savez toujours où vous en êtes." },
        { k: "02", t: "Réponse en 24h", d: "Nous vous répondons sous 24 heures – de manière fiable et personnelle." },
        { k: "03", t: "Personnel & discret", d: "Un interlocuteur dédié qui comprend votre situation sur le long terme." },
      ],
    },
    servicesPreview: {
      eyebrow: "Notre expertise",
      title: "Tout au même endroit",
      subtitle: "De l'assurance de base à la prévoyance – nous structurons votre couverture avec clarté et vision.",
      cta: "Voir tous les services",
    },
    servicesList: [
      { id: "krankenversicherung", t: "Assurance maladie", d: "Votre santé entre de bonnes mains. Nous comparons les couvertures de base et complémentaires." },
      { id: "lebensversicherung", t: "Assurance vie 3a / 3b", d: "Protégez vos proches et votre prévoyance sur le long terme." },
      { id: "motorfahrzeug", t: "Assurance véhicule", d: "Protection pour la voiture, les occupants et les dommages – à conditions équitables." },
      { id: "hausrat", t: "Assurance ménage", d: "Votre foyer mérite la meilleure protection contre incendie, eau et vol." },
      { id: "privathaftpflicht", t: "Responsabilité civile", d: "Bien couvert lorsque le quotidien réserve des surprises." },
      { id: "rechtsschutz", t: "Protection juridique", d: "Un partenaire solide quand le droit compte." },
      { id: "reise", t: "Assurance voyage", d: "Voyagez l'esprit léger – nous vous protégeons dans le monde entier." },
      { id: "kmu", t: "Assurance PME", d: "Protection globale pour votre entreprise et vos collaborateurs." },
      { id: "steuererklaerung", t: "Déclaration d'impôt", d: "Nous remplissons votre déclaration – prix fixe dès CHF 79.–." },
    ],
    servicesPage: {
      eyebrow: "Prestations",
      title: "Nos services en un coup d'œil",
      subtitle: "Huit domaines de compétence, un seul interlocuteur. Chaque conseil est adapté à votre situation de vie.",
    },
    about: {
      eyebrow: "À propos",
      title: "Un partenaire. Pour tout ce qui compte.",
      p1: "OmniServe-Solutions est votre point de contact indépendant pour l'assurance, la finance et l'administration en Suisse. Nous associons la précision suisse à une approche humaine.",
      p2: "Notre engagement : que vous vous sentiez en sécurité – aujourd'hui, demain et à chaque étape de la vie. C'est pourquoi nous prenons le temps d'écouter et de trouver la solution qui vous convient vraiment.",
      valuesTitle: "Nos valeurs",
      values: [
        { t: "Indépendance", d: "Nous analysons le marché et ne recommandons que ce qui vous sert réellement." },
        { t: "Vision long terme", d: "Nous pensons en décennies, pas en commissions." },
        { t: "Clarté", d: "Un langage simple, des propositions transparentes, des décisions claires." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Parlons-en.",
      subtitle: "Décrivez votre demande – nous répondrons sous 24 heures avec une proposition personnelle.",
      form: {
        name: "Nom", email: "E-mail", phone: "Téléphone (optionnel)", service: "Domaine d'intérêt", servicePh: "Veuillez choisir…", message: "Votre message", submit: "Envoyer la demande", sending: "Envoi…",
        success: "Merci ! Nous vous recontactons rapidement.",
        error: "Une erreur est survenue. Veuillez réessayer.",
      },
      details: { addressLabel: "Adresse", address: "Rigistrasse 2, 5610 Wohlen", emailLabel: "E-mail", webLabel: "Web", phoneLabel: "Téléphone", hoursLabel: "Horaires", hours: "Lu–Ve · 15:00 – 19:00" },
    },
    tax: {
      eyebrow: "Nouveau · Prix fixe",
      title: "Nous remplissons votre déclaration d'impôt",
      subtitle: "Nous prenons en charge votre déclaration – professionnel, ponctuel, à prix fixe transparent.",
      cta: "Prendre rendez-vous",
      note: "Prix en CHF. Soumission numérique incluse.",
      badge: "Populaire",
      currency: "CHF",
      tiers: [
        { name: "Personne seule", price: "79", desc: "Pour les célibataires. Traitement complet, soumission numérique.", features: ["Remplissage complet", "Soumission numérique", "Déductions optimisées", "Conseil personnel"] },
        { name: "Famille", price: "99", desc: "Pour les couples & familles. Toutes les déductions, aucun souci.", features: ["Tout de Personne seule", "Déductions famille & enfants", "Splitting des époux", "Traitement prioritaire"], featured: true },
        { name: "Avec bien immobilier", price: "119", desc: "Si vous êtes propriétaire. Incl. valeur locative & frais d'entretien.", features: ["Tout de Famille", "Valeur locative propre", "Déduction frais d'entretien", "Intérêts hypothécaires"] },
      ],
    },
    footer: {
      tagline: "Conseil en assurance, finance & déclaration d'impôt – personnel, fiable, compétent.",
      rights: "Tous droits réservés.",
      privacy: "Confidentialité",
      imprint: "Mentions légales",
    },
  },

  it: {
    nav: { home: "Home", services: "Servizi", tax: "Dichiarazione", about: "Chi siamo", contact: "Contatto", cta: "Richiedi offerta" },
    hero: {
      eyebrow: "Assicurazioni · Finanza · Dichiarazione redditi",
      title: "Una fiducia che si",
      titleAccent: "sente.",
      subtitle: "Supportiamo privati, famiglie e liberi professionisti in Svizzera con una consulenza personale e trasparente – tutto da un unico interlocutore.",
      primary: "Offerta gratuita",
      secondary: "I nostri servizi",
    },
    trust: {
      title: "Perché OmniServe",
      headline: "Uno standard che non si misura in compromessi.",
      items: [
        { k: "01", t: "Trasparente & equo", d: "Comunicazione chiara, nessun costo nascosto. Sapete sempre a che punto siete." },
        { k: "02", t: "Risposta in 24h", d: "Vi ricontattiamo entro 24 ore – affidabili e personali." },
        { k: "03", t: "Personale & discreto", d: "Un referente dedicato che comprende la vostra situazione nel lungo termine." },
      ],
    },
    servicesPreview: {
      eyebrow: "La nostra competenza",
      title: "Tutto da un unico interlocutore",
      subtitle: "Dall'assicurazione di base alla previdenza – strutturiamo la vostra copertura con chiarezza e visione.",
      cta: "Vedi tutti i servizi",
    },
    servicesList: [
      { id: "krankenversicherung", t: "Assicurazione malattia", d: "La vostra salute in ottime mani. Confrontiamo copertura di base e complementare." },
      { id: "lebensversicherung", t: "Assicurazione vita 3a / 3b", d: "Proteggete i vostri cari e la vostra previdenza a lungo termine." },
      { id: "motorfahrzeug", t: "Assicurazione veicoli", d: "Protezione per auto, occupanti e danni – a condizioni eque." },
      { id: "hausrat", t: "Assicurazione mobilia", d: "La vostra casa merita la migliore protezione da incendio, acqua e furto." },
      { id: "privathaftpflicht", t: "Responsabilità civile", d: "Ben protetti quando la vita quotidiana riserva sorprese." },
      { id: "rechtsschutz", t: "Tutela legale", d: "Un partner forte quando il diritto conta." },
      { id: "reise", t: "Assicurazione viaggi", d: "Viaggiate sereni – vi proteggiamo in tutto il mondo." },
      { id: "kmu", t: "Assicurazione PMI", d: "Protezione completa per la vostra azienda e i vostri collaboratori." },
      { id: "steuererklaerung", t: "Dichiarazione dei redditi", d: "Compiliamo la vostra dichiarazione – prezzo fisso da CHF 79.–." },
    ],
    servicesPage: {
      eyebrow: "Prestazioni",
      title: "I nostri servizi in sintesi",
      subtitle: "Otto aree di competenza, un solo referente. Ogni consulenza è su misura per la vostra situazione di vita.",
    },
    about: {
      eyebrow: "Chi siamo",
      title: "Un partner. Per tutto ciò che conta.",
      p1: "OmniServe-Solutions è il vostro punto di contatto indipendente per assicurazioni, finanza e amministrazione in Svizzera. Uniamo la precisione svizzera al calore umano.",
      p2: "Il nostro impegno: farvi sentire sicuri – oggi, domani e in ogni fase della vita. Per questo dedichiamo tempo all'ascolto e cerchiamo la soluzione davvero giusta per voi.",
      valuesTitle: "I nostri valori",
      values: [
        { t: "Indipendenza", d: "Analizziamo il mercato e raccomandiamo solo ciò che vi serve davvero." },
        { t: "Lungo termine", d: "Pensiamo in decenni, non in commissioni." },
        { t: "Chiarezza", d: "Linguaggio semplice, proposte trasparenti, decisioni chiare." },
      ],
    },
    contact: {
      eyebrow: "Contatto",
      title: "Parliamone.",
      subtitle: "Descrivete la vostra richiesta – risponderemo entro 24 ore con una proposta personale.",
      form: {
        name: "Nome", email: "E-mail", phone: "Telefono (opzionale)", service: "Area di interesse", servicePh: "Selezionare…", message: "Il vostro messaggio", submit: "Invia richiesta", sending: "Invio…",
        success: "Grazie! Vi ricontatteremo a breve.",
        error: "Qualcosa è andato storto. Riprovate.",
      },
      details: { addressLabel: "Indirizzo", address: "Rigistrasse 2, 5610 Wohlen", emailLabel: "E-mail", webLabel: "Web", phoneLabel: "Telefono", hoursLabel: "Orari", hours: "Lu–Ve · 15:00 – 19:00" },
    },
    tax: {
      eyebrow: "Novità · Prezzo fisso",
      title: "Compiliamo la vostra dichiarazione dei redditi",
      subtitle: "Ci occupiamo della vostra dichiarazione – professionale, puntuale, a prezzo fisso trasparente.",
      cta: "Prenota un appuntamento",
      note: "Prezzi in CHF. Trasmissione digitale inclusa.",
      badge: "Popolare",
      currency: "CHF",
      tiers: [
        { name: "Persona singola", price: "79", desc: "Per single. Elaborazione completa, trasmissione digitale.", features: ["Compilazione completa", "Trasmissione digitale", "Detrazioni ottimizzate", "Consulenza personale"] },
        { name: "Famiglia", price: "99", desc: "Per coppie e famiglie. Tutte le detrazioni, tutti i figli.", features: ["Tutto di Persona singola", "Detrazioni famiglia e figli", "Splitting dei coniugi", "Elaborazione prioritaria"], featured: true },
        { name: "Con immobili", price: "119", desc: "Se possedete immobili. Incl. valore locativo & costi di manutenzione.", features: ["Tutto di Famiglia", "Valore locativo proprio", "Detrazione manutenzione", "Interessi ipotecari"] },
      ],
    },
    footer: {
      tagline: "Consulenza assicurativa, finanza & dichiarazione dei redditi – personale, affidabile, competente.",
      rights: "Tutti i diritti riservati.",
      privacy: "Privacy",
      imprint: "Note legali",
    },
  },

  ta: {
    nav: { home: "முகப்பு", services: "சேவைகள்", tax: "வரி அறிக்கை", about: "எங்களைப் பற்றி", contact: "தொடர்பு", cta: "விலைப் புள்ளி கேளுங்கள்" },
    hero: {
      eyebrow: "காப்பீடு · நிதி · வரி அறிக்கை",
      title: "நம்பிக்கை உங்களுக்கு",
      titleAccent: "உணரக்கூடியது.",
      subtitle: "சுவிட்சர்லாந்தில் தனிநபர்கள், குடும்பங்கள் மற்றும் சுயதொழில் புரிபவர்களுக்கு தனிப்பட்ட, வெளிப்படையான ஆலோசனை – ஒரே இடத்தில் அனைத்தும்.",
      primary: "இலவச விலைப் புள்ளி",
      secondary: "எங்கள் சேவைகள்",
    },
    trust: {
      title: "ஏன் OmniServe",
      headline: "சமரசங்களில் அளவிடப்படாத தரம்.",
      items: [
        { k: "01", t: "வெளிப்படை & நியாயம்", d: "தெளிவான தகவல் பரிமாற்றம், மறைவான கட்டணங்கள் இல்லை. நீங்கள் எப்போதும் தெரிந்திருப்பீர்கள்." },
        { k: "02", t: "24 மணி நேரத்தில் பதில்", d: "24 மணி நேரத்திற்குள் நாங்கள் உங்களைத் தொடர்பு கொள்வோம் – நம்பகமாகவும் தனிப்பட்ட முறையிலும்." },
        { k: "03", t: "தனிப்பட்ட & இரகசியமான", d: "உங்கள் சூழலைப் புரிந்துகொண்டு நீண்டகாலம் உடன் இருக்கும் ஒரு ஆலோசகர்." },
      ],
    },
    servicesPreview: {
      eyebrow: "எங்கள் நிபுணத்துவம்",
      title: "ஒரே இடத்தில் அனைத்தும்",
      subtitle: "அடிப்படை காப்பீட்டிலிருந்து ஓய்வூதிய திட்டமிடல் வரை – தெளிவுடன் உங்கள் பாதுகாப்பை அமைக்கிறோம்.",
      cta: "அனைத்து சேவைகளையும் காண",
    },
    servicesList: [
      { id: "krankenversicherung", t: "உடல்நல காப்பீடு", d: "உங்கள் ஆரோக்கியம் சிறந்த கைகளில். அடிப்படை மற்றும் கூடுதல் காப்பீட்டை ஒப்பிடுகிறோம்." },
      { id: "lebensversicherung", t: "வாழ்க்கை காப்பீடு 3a / 3b", d: "உங்கள் அன்பானவர்களையும் ஓய்வூதியத்தையும் நீண்டகாலமாக பாதுகாக்கவும்." },
      { id: "motorfahrzeug", t: "வாகன காப்பீடு", d: "கார், பயணிகள் மற்றும் சேதங்களுக்கு நியாயமான விதிமுறைகளில் பாதுகாப்பு." },
      { id: "hausrat", t: "வீட்டு காப்பீடு", d: "உங்கள் வீடு தீ, நீர் மற்றும் திருட்டுக்கு எதிராக சிறந்த பாதுகாப்பை தகுதி பெற்றது." },
      { id: "privathaftpflicht", t: "தனிப்பட்ட பொறுப்பு", d: "தினசரி வாழ்வில் எதிர்பாராத நிகழ்வுகள் ஏற்படும்போது நன்கு பாதுகாக்கப்பட்டுள்ளீர்கள்." },
      { id: "rechtsschutz", t: "சட்ட பாதுகாப்பு", d: "சட்டரீதியாக முக்கியமான நேரங்களில் வலிமையான கூட்டாளர்." },
      { id: "reise", t: "பயண காப்பீடு", d: "கவலையின்றி பயணிக்கவும் – உலகெங்கும் நாங்கள் உங்களைப் பாதுகாக்கிறோம்." },
      { id: "kmu", t: "SME காப்பீடு", d: "உங்கள் நிறுவனம் மற்றும் ஊழியர்களுக்கான முழுமையான பாதுகாப்பு." },
      { id: "steuererklaerung", t: "வரி அறிக்கை", d: "உங்கள் வரி அறிக்கையை நாங்கள் நிரப்புகிறோம் – நிலையான விலை CHF 79.– முதல்." },
    ],
    servicesPage: {
      eyebrow: "சேவைகள்",
      title: "எங்கள் சேவைகள் ஒரே பார்வையில்",
      subtitle: "எட்டு நிபுணத்துவ துறைகள், ஒரே தொடர்பு புள்ளி. ஒவ்வொரு ஆலோசனையும் உங்கள் வாழ்க்கை சூழலுக்கு ஏற்றது.",
    },
    about: {
      eyebrow: "எங்களைப் பற்றி",
      title: "ஒரு கூட்டாளி. முக்கியமான அனைத்திற்கும்.",
      p1: "OmniServe-Solutions சுவிட்சர்லாந்தில் காப்பீடு, நிதி மற்றும் நிர்வாகத்திற்கான உங்கள் சுயாதீன தொடர்பு புள்ளி. சுவிஸ் துல்லியத்தை மனிதப் பரிவுடன் இணைக்கிறோம்.",
      p2: "எங்கள் உறுதிமொழி: நீங்கள் பாதுகாப்பாக உணர வேண்டும் – இன்று, நாளை மற்றும் வாழ்க்கையின் ஒவ்வொரு கட்டத்திலும். அதனால்தான் நாங்கள் நேரம் எடுத்து கேட்டு, உண்மையில் பொருந்தும் தீர்வை கண்டுபிடிக்கிறோம்.",
      valuesTitle: "எங்கள் மதிப்புகள்",
      values: [
        { t: "சுயாதீனம்", d: "சந்தையை ஆராய்ந்து, உங்களுக்கு உண்மையிலேயே பயனுள்ளதை மட்டுமே பரிந்துரைக்கிறோம்." },
        { t: "நீண்ட கால சிந்தனை", d: "நாங்கள் தசாப்தங்களில் சிந்திக்கிறோம், கமிஷனில் அல்ல." },
        { t: "தெளிவு", d: "எளிய மொழி, வெளிப்படையான முன்மொழிவுகள், தெளிவான முடிவுகள்." },
      ],
    },
    contact: {
      eyebrow: "தொடர்பு",
      title: "பேசுவோம்.",
      subtitle: "உங்கள் கோரிக்கையை விவரிக்கவும் – 24 மணி நேரத்திற்குள் தனிப்பட்ட முன்மொழிவுடன் நாங்கள் பதிலளிப்போம்.",
      form: {
        name: "பெயர்", email: "மின்னஞ்சல்", phone: "தொலைபேசி (விருப்பம்)", service: "ஆர்வமுள்ள துறை", servicePh: "தேர்வு செய்யவும்…", message: "உங்கள் செய்தி", submit: "கோரிக்கை அனுப்பு", sending: "அனுப்புகிறது…",
        success: "நன்றி! விரைவில் உங்களைத் தொடர்பு கொள்வோம்.",
        error: "ஏதோ தவறு நடந்துவிட்டது. மீண்டும் முயற்சிக்கவும்.",
      },
      details: { addressLabel: "முகவரி", address: "Rigistrasse 2, 5610 Wohlen", emailLabel: "மின்னஞ்சல்", webLabel: "வலைத்தளம்", phoneLabel: "தொலைபேசி", hoursLabel: "திறந்திருக்கும் நேரம்", hours: "திங்–வெள் · 15:00 – 19:00" },
    },
    tax: {
      eyebrow: "புதிய · நிலையான விலை",
      title: "வரி அறிக்கை நிரப்புதல்",
      subtitle: "உங்கள் வரி அறிக்கையை நாங்கள் நிரப்புகிறோம் – தொழில் ரீதியாக, சரியான நேரத்தில், வெளிப்படையான நிலையான விலைக்கு.",
      cta: "சந்திப்பு பதிவு",
      note: "விலைகள் CHF இல். டிஜிட்டல் சமர்ப்பிப்பு உட்பட.",
      badge: "பிரபலமான",
      currency: "CHF",
      tiers: [
        { name: "தனிநபர்", price: "79", desc: "தனிநபர்களுக்கு. முழுமையான செயலாக்கம், டிஜிட்டல் சமர்ப்பிப்பு.", features: ["முழுமையான நிரப்புதல்", "டிஜிட்டல் சமர்ப்பிப்பு", "உகந்த கழிவுகள்", "தனிப்பட்ட ஆலோசனை"] },
        { name: "குடும்பம்", price: "99", desc: "தம்பதிகள் & குடும்பங்களுக்கு. அனைத்து கழிவுகளும்.", features: ["தனிநபரின் அனைத்தும்", "குடும்பம் & குழந்தை கழிவுகள்", "வாழ்க்கைத் துணை பிரிப்பு", "முன்னுரிமை செயலாக்கம்"], featured: true },
        { name: "சொத்துகளுடன்", price: "119", desc: "வீட்டு உரிமை உள்ளவர்களுக்கு. வாடகை மதிப்பு & பராமரிப்பு உட்பட.", features: ["குடும்பத்தின் அனைத்தும்", "சொந்த வாடகை மதிப்பு", "பராமரிப்பு கழிவுகள்", "அடமான வட்டி"] },
      ],
    },
    footer: {
      tagline: "காப்பீட்டு ஆலோசனை, நிதி & வரி அறிக்கை – தனிப்பட்ட, நம்பகமான, திறமையான.",
      rights: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
      privacy: "தனியுரிமை",
      imprint: "சட்ட குறிப்பு",
    },
  },
};

export const languageOptions = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "it", label: "IT" },
  { code: "ta", label: "TA" },
];
